var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isCoOwnership)?_c('co-ownership-sales',{attrs:{"building":_vm.building,"contractor-name":_vm.contractorName}}):_c('sole-ownership-sale',{attrs:{"building":_vm.building,"project-type":_vm.projectType,"contractor-name":_vm.contractorName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }